module.exports = __webpack_public_path__ + "img/text-capitalize.eba180f0.svg";